import React, { useContext } from 'react';
import { useSelector } from 'react-redux';

import { SubnodeOutlined } from '@ant-design/icons';

import { Dropdown, Menu } from 'antd';

import RibbonButton from 'common/components/button/RibbonButton';

import gridSelector from 'common/components/grid-view/controllers/selectors';

import MoveGlnToMember from './MoveGlnToMember';
import MoveAllToMember from 'pages/home/ribbon/components/sections/shared/MoveAllToMember';
import CreateNewMember from './CreateNewMember';
import MemberManagementCreateModal from 'pages/home/ribbon/components/modal/member-management/MemberManagementCreateModal';
import ParentChildMemberHierarchies from 'pages/home/ribbon/components/sections/shared/ParentChildMemberHierarchies';

import { AbilityContext } from 'context/Can';
import { ABILITY_ACTION, ABILITY_SUBJECT } from 'static/Permission';
import {
  MoveAllEntitiesToMemberModal,
  ReassignGLNToMemberModal,
} from 'common/components/modal';

import * as memberServices from 'services/members';
import { useCheckIsSuperAdmin } from 'hooks';

const MemberActions = () => {
  const ability = useContext(AbilityContext);
  const canCreateMember = ability.can(
    ABILITY_ACTION.CREATE,
    ABILITY_SUBJECT.MEMBER
  );

  const defaultProductParams = {
    searchText: '',
  };

  const selectedItemDetailList = useSelector(
    gridSelector.makeSelectDetailCurrentITemsSelection()
  );

  const firstSelectedMemberItem = selectedItemDetailList?.[0];

  const isSuperAdmin = useCheckIsSuperAdmin();

  const menuOptions = (
    <Menu>
      {canCreateMember ? (
        <Menu.Item key='create-member'>
          <CreateNewMember />
        </Menu.Item>
      ) : null}

      <Menu.Item key='move-all'>
        <MoveAllToMember
          disabled={selectedItemDetailList?.length !== 1 || !isSuperAdmin}
          selectedMember={selectedItemDetailList?.[0]}
        />
      </Menu.Item>

      <Menu.Item key='move-gln'>
        <MoveGlnToMember entityType='MEM' />
      </Menu.Item>
      <Menu.Item>
        <ParentChildMemberHierarchies
          disabled={selectedItemDetailList?.length !== 1}
          selectedMember={selectedItemDetailList?.[0]}
        />
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Dropdown overlay={menuOptions} placement='bottomLeft' arrow>
        <RibbonButton icon={<SubnodeOutlined />} label='Member Actions' />
      </Dropdown>
      <MoveAllEntitiesToMemberModal
        isMultiple={false}
        dataPath='data.allMembers'
        params={{ searchText: '' }}
        mapSearch={(searchText) => ({ searchText })}
        tagRender={{ value: (itemData) => itemData?.companyName }}
        itemIdName='companyId'
        originMember={selectedItemDetailList?.[0]}
      />

      <ReassignGLNToMemberModal
        title='Assign GLN(s) to Member'
        isMultiple={false}
        service={memberServices.getAllMemberForReassign}
        dataPath='data.allMembers'
        params={defaultProductParams}
        mapSearch={(searchText) => ({ searchText })}
        tagRender={{ value: (itemData) => itemData?.companyName }}
        itemIdName='companyId'
        glnList={firstSelectedMemberItem?.glns}
        memberId={firstSelectedMemberItem?.id}
      />

      <MemberManagementCreateModal />
    </>
  );
};

export default MemberActions;
